module.exports = __webpack_public_path__ + "static/media/tick.6bf11fc9.webp";